import React, { useContext, useState, useEffect, useRef } from 'react';
import { database, auth } from '../modules/fireBase';
import {
  Table,
  Input,
  Popconfirm,
  Form,
  Button,
  Typography,
  Tabs,
  Checkbox,
  Tooltip,
  BackTop,
} from 'antd';
import '../assets/styles/CarnetAdresse.css';
import phoneFormatter from 'phone-formatter';
import MaskedInput from 'antd-mask-input';
import CustomLayout from './CustomLayout';
import { FaUserFriends, FaMapMarkerAlt, FaTruck, FaStar } from 'react-icons/fa';
import { RiSteering2Line } from 'react-icons/ri';

const { Title } = Typography;
const { TabPane } = Tabs;

const dataSource = [];
export default function CarnetAdresse() {
  useEffect(() => {}, []);
  return (
    <CustomLayout
      selectedKey="5"
      contentStyle={{
        display: 'flex',
        flexDirection: 'column',
      }}>
      <Title>Carnet d'adresse</Title>
      <Tabs type="card">
        <TabPane tab="Chantier" key="1">
          <EditableTable type="chantierContacts" />
        </TabPane>
        <TabPane tab="Chargés de projets" key="2">
          <EditableTable type="bureauContacts" />
        </TabPane>
      </Tabs>
    </CustomLayout>
  );
}

const EditableCell = ({
  editing,
  dataIndex,
  title,
  inputType,
  record,
  index,
  children,
  ...restProps
}) => {
  const inputNode =
    inputType === 'phonenumber' ? (
      <MaskedInput mask="(111) 111-1111" size="10" />
    ) : inputType === 'checkbox' ? (
      <div style={{ textAlign: 'center' }}>
        <Checkbox defaultChecked={record[dataIndex]} />
      </div>
    ) : (
      <Input />
    );

  return (
    <td {...restProps}>
      {editing ? (
        <Form.Item
          name={dataIndex}
          style={{ margin: 0 }}
          rules={[
            {
              required: inputType === 'checkbox' ? false : true,
              message: `Veuillez indiquer un ${title}!`,
            },
          ]}
          valuePropName={inputType === 'checkbox' ? 'checked' : 'value'}
          //initialValue={inputType === 'checkbox' ? true : record.dataIndex}
        >
          {inputNode}
        </Form.Item>
      ) : (
        children
      )}
    </td>
  );
};

const EditableTable = ({ type }) => {
  const [form] = Form.useForm();
  const [data, setData] = useState(dataSource);
  const [editingKey, setEditingKey] = useState('');

  useEffect(() => {
    database.ref(type).on('value', (snapshot) => {
      if (snapshot.val()) {
        var firebaseData = Object.values(snapshot.val()).map((item, index) => {
          return {
            key: Object.keys(snapshot.val())[index],
            ...item,
          };
        });
        setData(firebaseData);
      }
    });
  }, []);

  const isEditing = (record) => record.key === editingKey;

  const add = () => {
    if (!editingKey) {
      var newContactRef = database.ref(type).push();
      const clearContact = {
        prenom: '',
        nom: '',
        phonenumber: '',
        direequipe: true,
        direprojet: true,
        direcamion: true,
        direchauffeur: true,
        direchefequipe: true,
      };
      /*newContactRef.set({
        ...clearContact,
      });*/
      const newData = [...data];
      newData.push({
        key: newContactRef.key,
        ...clearContact,
      });
      form.setFieldsValue({ ...clearContact });
      //console.log(newData);
      setData(newData);
      setEditingKey(newContactRef.key);
    }
  };

  const edit = (record) => {
    form.setFieldsValue({ ...record });
    //console.log(record);
    setEditingKey(record.key);
  };

  const cancel = (key) => {
    const newData = [...data];
    const index = newData.findIndex((item) => key === item.key);
    if (index > -1) {
      const item = newData[index];
      if (item.nom === '' && item.prenom === '' && item.phonenumber === '') {
        newData.splice(index, 1);
        setData(newData);
      }
    }
    setEditingKey('');
  };

  const save = async (key) => {
    try {
      const row = await form.validateFields();
      //console.log(row);
      //console.log(key);
      const newData = [...data];
      const index = newData.findIndex((item) => key === item.key);
      if (index > -1) {
        database.ref(type).child(key).set(row);
        const item = newData[index];
        newData.splice(index, 1, {
          ...item,
          ...row,
        });
        setData(newData);
        setEditingKey('');
      } /*else {
        newData.push(row);
        setData(newData);
        setEditingKey('');
      }*/
    } catch (errInfo) {
      console.log('Validate Failed:', errInfo);
    }
  };

  const supprimer = (key) => {
    const newData = [...data];
    const index = newData.findIndex((item) => key === item.key);
    //console.log(index);
    if (index > -1) {
      const item = newData[index];
      newData.splice(index, 1);
      setData(newData);
      database.ref(type).child(key).remove();
    }
  };

  const handleDireEquipeChange = (data) => {
    //console.log(data);
    let ref = database
      .ref('chantierContacts')
      .child(data.key)
      .transaction((contact) => {
        if (contact) {
          contact.direequipe = !contact.direequipe;
        }
        return contact;
      });
  };
  const handleDireChefEquipeChange = (data) => {
    //console.log(data);
    let ref = database
      .ref('chantierContacts')
      .child(data.key)
      .transaction((contact) => {
        if (contact) {
          contact.direchefequipe = !contact.direchefequipe;
        }
        return contact;
      });
  };
  const handleDireProjetChange = (data) => {
    //console.log(data);
    let ref = database
      .ref('chantierContacts')
      .child(data.key)
      .transaction((contact) => {
        if (contact) {
          contact.direprojet = !contact.direprojet;
        }
        return contact;
      });
  };
  const handleDireCamionChange = (data) => {
    //console.log(data);
    let ref = database
      .ref('chantierContacts')
      .child(data.key)
      .transaction((contact) => {
        if (contact) {
          contact.direcamion = !contact.direcamion;
        }
        return contact;
      });
  };
  const handleDireChauffeurChange = (data) => {
    //console.log(data);
    let ref = database
      .ref('chantierContacts')
      .child(data.key)
      .transaction((contact) => {
        if (contact) {
          contact.direchauffeur = !contact.direchauffeur;
        }
        return contact;
      });
  };

  let columns = [
    {
      title: 'Nom',
      dataIndex: 'nom',
      //width: '25%',
      editable: true,
      defaultSortOrder: 'ascend',
      sorter: (a, b) => a.nom.localeCompare(b.nom),
    },
    {
      title: 'Prénom',
      dataIndex: 'prenom',
      //width: '25%',
      editable: true,
      sorter: (a, b) => a.prenom.localeCompare(b.prenom),
    },
    {
      title: 'Téléphone',
      dataIndex: 'phonenumber',
      //width: '30%',
      editable: true,
      render: (phonenumber) =>
        phoneFormatter.format(phonenumber, '(NNN) NNN-NNNN'),
    },
    {
      title: '',
      dataIndex: 'operation',
      width: '20%',
      render: (_, record) => {
        const editable = isEditing(record);
        return editable ? (
          <>
            <Button
              type="primary"
              onClick={() => save(record.key)}
              style={{ marginRight: 8 }}>
              Enregistrer
            </Button>
            <Popconfirm
              title="Êtes-vous certain de vouloir annuler?"
              cancelText="Annuler"
              onConfirm={() => cancel(record.key)}>
              <Button type="danger">Annuler</Button>
            </Popconfirm>
          </>
        ) : (
          <>
            <Button
              type="primary"
              disabled={editingKey !== ''}
              onClick={() => edit(record)}
              style={{ marginRight: 8 }}>
              Modifier
            </Button>
            <Popconfirm
              title="Êtes-vous certain de vouloir supprimer le contact?"
              cancelText="Annuler"
              onConfirm={() => supprimer(record.key)}>
              <Button type="danger" disabled={editingKey !== ''}>
                Supprimer
              </Button>
            </Popconfirm>
          </>
        );
      },
    },
  ];
  if (type === 'chantierContacts') {
    columns.splice(3, 0, {
      title: (
        <div style={{ textAlign: 'center' }}>
          <Tooltip title="Avertir l'employé des membres de l'équipe?">
            <FaUserFriends />
          </Tooltip>
        </div>
      ),
      dataIndex: 'direequipe',
      //width: '10%',
      editable: true,
      render: (value, record, rowIndex) => (
        <div style={{ textAlign: 'center' }}>
          <Checkbox
            checked={value}
            onChange={() => handleDireEquipeChange(record)}
          />
        </div>
      ),
      width: 50,
    });
    columns.splice(3, 0, {
      title: (
        <div style={{ textAlign: 'center' }}>
          <Tooltip title="Avertir l'employé s'il est contremaître?">
            <FaStar />
          </Tooltip>
        </div>
      ),
      dataIndex: 'direchefequipe',
      //width: '10%',
      editable: true,
      render: (value, record, rowIndex) => (
        <div style={{ textAlign: 'center' }}>
          <Checkbox
            checked={value}
            onChange={() => handleDireChefEquipeChange(record)}
          />
        </div>
      ),
      width: 50,
    });
    columns.splice(3, 0, {
      title: (
        <div style={{ textAlign: 'center' }}>
          <Tooltip title="Avertir l'employé s'il est le chauffeur?">
            <RiSteering2Line />
          </Tooltip>
        </div>
      ),
      dataIndex: 'direchauffeur',
      //width: '10%',
      editable: true,
      render: (value, record, rowIndex) => (
        <div style={{ textAlign: 'center' }}>
          <Checkbox
            checked={value}
            onChange={() => handleDireChauffeurChange(record)}
          />
        </div>
      ),
      width: 50,
    });
    columns.splice(3, 0, {
      title: (
        <div style={{ textAlign: 'center' }}>
          <Tooltip title="Avertir l'employé du camion?">
            <FaTruck />
          </Tooltip>
        </div>
      ),
      dataIndex: 'direcamion',
      //width: '10%',
      editable: true,
      render: (value, record, rowIndex) => (
        <div style={{ textAlign: 'center' }}>
          <Checkbox
            checked={value}
            onChange={() => handleDireCamionChange(record)}
          />
        </div>
      ),
      width: 50,
    });
    columns.splice(3, 0, {
      title: (
        <div style={{ textAlign: 'center' }}>
          <Tooltip title="Avertir l'employé du projet?">
            <FaMapMarkerAlt />
          </Tooltip>
        </div>
      ),
      dataIndex: 'direprojet',
      //width: '10%',
      editable: true,
      render: (value, record, rowIndex) => (
        <div style={{ textAlign: 'center' }}>
          <Checkbox
            checked={value}
            onChange={() => handleDireProjetChange(record)}
          />
        </div>
      ),
      width: 50,
    });
  }
  const mergedColumns = columns.map((col) => {
    if (!col.editable) {
      return col;
    }
    let type;
    switch (col.dataIndex) {
      case 'phonenumber':
        type = 'phonenumber';
        break;
      case 'direequipe':
        type = 'checkbox';
        break;
      case 'direchefequipe':
        type = 'checkbox';
        break;
      case 'direprojet':
        type = 'checkbox';
        break;
      case 'direcamion':
        type = 'checkbox';
        break;
      case 'direchauffeur':
        type = 'checkbox';
        break;
      default:
        type = 'text';
        break;
    }
    return {
      ...col,
      onCell: (record) => ({
        record,
        inputType: type,
        dataIndex: col.dataIndex,
        title: col.title,
        editing: isEditing(record),
      }),
    };
  });

  return (
    <div>
      <div
        style={{ textAlign: 'left', marginBottom: '10px', marginLeft: '20px' }}>
        <Button type="primary" onClick={() => add()}>
          Ajouter
        </Button>
      </div>
      <Form form={form} component={false}>
        <Table
          components={{
            body: {
              cell: EditableCell,
            },
          }}
          bordered
          dataSource={data}
          columns={mergedColumns}
          rowClassName="editable-row"
          pagination={false}
          //sticky
          scroll={{ y: 'calc(100vh - 300px)' }}
          //rowSelection={type === 'chantierContacts' && rowSelection}
        />
        <BackTop
          target={() => document.getElementsByClassName('ant-table-body')[0]}
        />
      </Form>
    </div>
  );
};
